<template>
    <div id="about" class="">


      <div class="about-jumbotron parallax">
        <h2 class="about-jumbotron-content ">{{$t('message.about_us.title')}}</h2>
      </div>

      <div class="container">
        <div class="row justify-content-center">

            <!-- SLIDER HERE -->
            <!-- SUBTITLE -->
            <!-- IMAGE -->
            <!-- TEXT -->
        </div>

        <!-- CONTACT US BUTTON -->

    </div>

</div>

    
</template>

<script>

export default {
  name: 'AboutView',
  components: {


  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

.about-jumbotron {
  background-image: url("../assets/galleria-stefano-forni.jpg");
  position: relative;
  height: 300px;
  overflow: hidden;
  background-attachment: fixed; /* Effetto parallax */
  background-position: 60% 20%;
  background-size: cover;
  background-repeat: no-repeat; /* Impedisce la ripetizione dell'immagine */
}
/* Overlay trasparente sopra l'immagine */
.about-jumbotron::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Sfondo nero semi-trasparente */
  z-index: 1; /* Metti l'overlay sopra l'immagine ma sotto il testo */
}


/* Parallax effect */
.parallax {
  background-attachment: fixed;
  background-repeat: no-repeat; /* Assicura che l'immagine non si ripeta */
}
.about-jumbotron-content {
  position: absolute;
  bottom: 0; /* Distanza dal bordo inferiore */
  z-index: 2; /* Assicurati che il testo sia sopra l'overlay */
  color: white;
  font-size: 34px;
  text-align: center;
   /* top: 50%; */
  left: 50%;
  transform: translate(-50%, -50%); /* Centra perfettamente il testo */
}

</style>